import * as React from 'react';
import { BasePureComponent } from '../BaseComponent';
import * as Dati from '../../Dati';
import { Trad } from '../../components/';

interface IAddendumDataRubrica {
    Data: string;
    RenderFormField: any;
}

export class AddendumDataRubrica extends BasePureComponent<IAddendumDataRubrica> {
    private _Type: Dati.TDictTipo = {};
    
    public constructor(props: any) {
        super(props);

        this._Type = {};
        this._Type["1"] = new Dati.CTipo("1", "Telefono");
        this._Type["2"] = new Dati.CTipo("2", "Cellulare");
        this._Type["3"] = new Dati.CTipo("3", "Fax");
        this._Type["4"] = new Dati.CTipo("4", "Email");
        this._Type["5"] = new Dati.CTipo("5", "PEC");
    }

    public render() {
        const data = JSON.parse(this.props.Data);
        const elementGroup = [];

        for (let key in data) {
            let value: any = '';
            switch (key) {
                case "ID_Tipologia":
                    value = Trad.Trad(this._Type[data[key]].Valore);
                    break;
                case "TipoRecapito":
                    value = data[key] === 'PR'? Trad.Trad("Professionale") : Trad.Trad("Personale")
                    break;
                case "Valore":
                    value = data[key];
                    break;
            }
            elementGroup.push({
                CampoAppendice: key,
                ValoreAppendice: value
            });
        }
        return elementGroup.map(item => this.props.RenderFormField(item));
    }
}



// WEBPACK FOOTER //
// ./src/components/AddendumList/AddendumDataRubrica.tsx